import React from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ModalCentered } from "components/generic/ModalCentered";
import { http } from "api/HttpClient";
import { ClearTemporaryBookingRequest, ClearTemporaryBookingResponse } from "generated/types/types";
import BeatLoader from "react-spinners/BeatLoader";
import { useTranslation } from "react-i18next";

interface Props {
    apiRequest: ClearTemporaryBookingRequest;
    onSuccess: () => void;
    onCancel: () => void;
}

export const ClearTemporaryBooking = (props: Props) => {

    const { t } = useTranslation();
    const [isApiLoading, setIsApiLoading] = React.useState(false);

    const onContinue = () => {
        if (isApiLoading) return;
        setIsApiLoading(true);
        http.post<ClearTemporaryBookingResponse>("/Booking/ClearTemporaryBooking", props.apiRequest)
            .then(({ data }) => {
                if (data.isSuccessful) {
                    props.onSuccess();
                    return;
                }
                throw Error();
            })
            .catch(() => {
                toast.error(t("clear_temp_booking_unable"));
                props.onCancel();
            });
    }

    const onCancel = () => {
        if (isApiLoading) return;
        props.onCancel();
    }

    return (
        <ModalCentered size="lg" show={true} contentClassName="custom-dialog p-4" onHide={() => { }}>
            <Modal.Body>
                <h2 className="mb-3">
                    {t("clear_temp_booking_remove_booking")}
                    <br />
                    {t("clear_temp_booking_continue")}
                </h2>
                <Button size="lg" onClick={onContinue}>
                    {isApiLoading ? <BeatLoader color={"white"} loading={true} /> : "Continue"}
                </Button>
                <Button size="lg" onClick={onCancel}>{t("clear_temp_booking_cancel")}</Button>
            </Modal.Body>
        </ModalCentered>
    );
}
